import _ from 'lodash';
import angular from 'angular';
import { saveAs } from 'file-saver';
import template from './events.html';


export default {
  name: 'reportsEvents',
  template,
  controller: EventsController,
  controllerAs: 'EventsCtrl',
  bindings: {
    options: '<',
    queryParams: '<',
    defaultTableOptions: '<'
  }
};

/* @ngInject */
function EventsController(
  $log,
  NgTableParams,
  ReportsService,
  DashboardInfoService,
  ModalService,
  EventInfoService,
  growl,
  appConfig,
  DashboardService,
  EquipmentInfoService
) {
  const vm = this;
  vm.MAX_EXCEL_EVENTS = 5000;

  // if false, controller will load event types / dashboards but will not load data for report
  // if true, will load data
  const _loadDataOnInitialize = false;

  vm.user = { admin: false };
  vm.notUsingIdFilter = true;

  vm.listOfDashboards = [];
  vm.eventNamesConfig = [];
  vm.playStates = {};
  vm.selectedDashboard = '';
  vm.selectedEventNames = [];
  vm.exportEventsCount = 0;
  vm.disableExport = true;

  vm.$onInit = initialize;
  vm.isExcelExportDisabled = isExcelExportDisabled;
  vm.exportDataToSpreadsheet = exportDataToSpreadsheet;
  vm.exportDataToCsv = exportDataToCsv;
  vm.generateEventsReport = generateEventsReport;
  vm.getData = getData;

  vm.deleteEvent = deleteEvent;
  vm.flagEvent = flagEvent;
  vm.saveEventNotes = saveEventNotes;
  vm.undeleteEvent = undeleteEvent;
  vm.invalidDate = ReportsService.invalidDate;
  vm.deepLink = ReportsService.deepLink;
  vm.handleDashboardSelectionChange = handleDashboardSelectionChange;

  vm.openEventDetailsModalSettings = ModalService.openEventDetailsModalSettings;
  vm.openCopyReportLink = ModalService.openCopyReportLink;

  let exportData = false;
  let exportType = 'excel';

  let allEventTypes;

  function initialize() {
    vm.user = appConfig.user;
    vm.tableOptions = angular.copy(vm.defaultTableOptions);
    vm.options = angular.copy(vm.options);
    vm.queryParams = angular.copy(vm.queryParams);
    parseQueryParams();
    loadDashboards();
    loadEventTypes();

    if (_loadDataOnInitialize) {
      createDataTable();
    }
  }

  // TODO: Break this big func into smaller chunks
  function getData($table) {
    const params = $table._params;
    vm.isLoading = true;
    let sortString = '';
    const paramsSorting = $table.sorting();
    if (paramsSorting) {
      const sortStringTempArray = [];
      _.forEach(paramsSorting, (value, key) => {
        sortStringTempArray.push(`${key}|${value}`);
      });
      sortString = sortStringTempArray.join('|');
    }
    let filterString = '';
    const filtered = $table.filter();
    const filKeys = _.keys(filtered);
    if (_.isEmpty(filtered)) {
      // reset if the user deletes any previously used filters
      vm.notUsingIdFilter = true;
    } else {
      // TODO:CLEANME This code is really showing its age...
      for (const [i, filKey] of filKeys.entries()) {
        const filVal = filtered[filKey];
        if (filVal !== '') {
          if (i > 0 && filterString !== '') {
            filterString += '|';
          }
          filterString += `${filKey}__${filVal}`;
          vm.notUsingIdFilter = true;
          // if filtering by event id, only send the id filter
          if (filKey === 'id') {
            vm.notUsingIdFilter = false;
            filterString = `${filKey}__${filVal}`;
            break;
          }
        }
      }
    }

    vm.options.page = params.page;
    vm.options.count = params.count;
    vm.options.filter = filterString;
    vm.options.sort = sortString;

    // if no dashboard is selected, send all of the dashboard IDs
    const dashboardsToSend = _.isObject(vm.selectedDashboard) ?
      [vm.selectedDashboard.id] :
      _.map(vm.listOfDashboards, 'id');

    vm.exportEventsCountLoading = true;
    // get report size
    ReportsService.reportSize(
      dashboardsToSend,
      vm.selectedEventNames,
      vm.options.date.start.toISOString(),
      vm.options.date.end.toISOString(),
      filterString,
      vm.options.includeDeleted
    )
      .then((res) => {
        vm.exportEventsCount = _.get(res, 'data.count', 0);
        vm.exportEventsCountLoading = false;
      })
      .catch(() => {
        vm.exportEventsCount = 0;
        vm.exportEventsCountLoading = false;
      });

    // get report
    return ReportsService.getEventsReportData(
      dashboardsToSend,
      vm.selectedEventNames,
      vm.options.date.start.toISOString(),
      vm.options.date.end.toISOString(),
      params.page,
      params.count,
      sortString,
      filterString,
      vm.options.includeDeleted,
      exportData,
      exportType
    )
      .then((success) => {
        const data = success.data;
        if (exportData && data) {
          exportData = false;
          const sta = vm.options.date.start;
          const end = vm.options.date.end;
          let dateRange = '';
          try {
            dateRange =
                ` (${sta.getMonth() + 1}.${sta.getDate()}.${sta.getFullYear()}.${sta.getHours()}.${sta.getMinutes()}`;
            dateRange +=
                `-${end.getMonth() + 1}.${end.getDate()}.${end.getFullYear()}.${end.getHours()}.${end.getMinutes()})`;
          } catch {
            dateRange = '';
          }

          const blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
          });
          const fileFormat = exportType === 'csv' ? '.csv' : '.xlsx';
          return saveAs(blob, `Events Report${dateRange}${fileFormat}`);
        } else if (data) {
          $table.total(data.count + ((params.page - 1) * params.count));
          vm.disableExport = _.isArray(data.events) ? data.events.length === 0 : true;
          return data.events;
        }
        return success;
      })
      .catch((error) => {
        const msg = error.error || error.data || 'Try exporting a smaller number of events.';
        growl.error(msg);
        $log.error(error);
        vm.exportEventsCount = 0;
        vm.exportEventsCountLoading = false;

        $table.log(`Error: ${error}`);
      })
      .finally(() => {
        vm.isLoading = false;
        exportData = false;
      });
  }

  function generateEventsReport() {
    if (vm.isLoading) {
      return;
    }
    if (vm.tableParams) {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    } else {
      createDataTable();
    }
  }

  function isExcelExportDisabled() {
    return vm.exportEventsCount > vm.MAX_EXCEL_EVENTS;
  }

  function exportDataToSpreadsheet() {
    exportData = true;
    exportType = 'excel';
    generateEventsReport();
  }

  function exportDataToCsv() {
    exportData = true;
    exportType = 'csv';
    generateEventsReport();
  }

  function undeleteEvent(eventId) {
    ReportsService.updateEvent(eventId, { deleted: false })
      .then((success) => {
        const updatedEvent = success.data[0];
        swapEvent(updatedEvent);
      });
  }

  function deleteEvent(eventId) {
    ReportsService.updateEvent(eventId, { deleted: true })
      .then((success) => {
        if (appConfig.user.admin) {
          // if superAdmin, then update the event in the table to reflect the change
          const updatedEvent = success.data[0];
          swapEvent(updatedEvent);
        } else {
          // if not a superAdmin, then remove the event from the table
          _.remove(vm.tableParams.data, dat => dat.id === eventId);
        }
      });
  }

  function swapEvent(updatedEvent, next = true) {
    _.forEach(vm.tableParams.data, (val) => {
      if (val.id === updatedEvent.id) {
        _.assign(val, updatedEvent);
        next = false;
      }
      return next;
    });
  }

  function loadDashboards() {
    return DashboardInfoService.getAllDashboards().then(onDashboardsReceived);
  }

  async function handleDashboardSelectionChange() {
    if (!vm.selectedDashboard) {
      vm.eventNamesConfig = allEventTypes;
      return;
    }

    const dashboardDetails = await DashboardService.getDashboardDetailsFromServer(vm.selectedDashboard.id);
    const equipmentIds = await DashboardInfoService.getEquipment(dashboardDetails);
    const fullEquipmentDetails = await EquipmentInfoService.getEquipmentById(equipmentIds);
    const equipmentTypes = new Set(fullEquipmentDetails.map(equipment => equipment.equipmentType));

    vm.eventNamesConfig = allEventTypes
      .filter(eventName => equipmentTypes.has(eventName.split('/').shift()))
      .sort();
  }

  function onDashboardsReceived(success) {
    vm.listOfDashboards = _
      .chain(success)
      .map(({ id, name }) => ({
        id,
        name,
      }))
      .sortBy('name')
      .value();
    if (vm.queryParams.dashboard) {
      // if user's list of dashboards contains the dashboard passed in query string,
      // select that dashboard
      // else, show growl and leave dashboard unselected.
      const theDash = _.find(vm.listOfDashboards, ['id', vm.queryParams.dashboard]);
      if (theDash) {
        vm.selectedDashboard = theDash;
      } else {
        growl.error('Dashboard not found', { title: 'Dashboard not found' });
        vm.selectedDashboard = '';
      }
    } else {
      vm.selectedDashboard = '';
    }
    safeDeleteQueryParams();
  }

  function loadEventTypes() {
    allEventTypes = _.map(EventInfoService.eventsConfig.definitions, 'eventName')
      .sort();
    if (_.size(vm.eventNamesConfig) === 0) {
      // Get all events for superAdmin or just the ones that should not be got by admin
      vm.eventNamesConfig = allEventTypes;
    }
    if (vm.queryParams.eventTypes) {
      const selectedEventNames = vm.queryParams.eventTypes.split('|');
      // if deep link included every single event type,
      // default to 'all event types'
      // instead of adding all event types to the selected list and manipulating the DOM.
      vm.selectedEventNames = selectedEventNames.length === vm.eventNamesConfig.length ? [] : selectedEventNames;
    }
    safeDeleteQueryParams();
  }

  function parseQueryParams() {
    const options = _.reduce(['page', 'count', 'sort', 'filter'], (acc, key) => {
      if (_.has(vm.queryParams, key)) {
        switch (key) {
          case 'page':
          case 'count':
            _.set(acc, key, _.get(vm.queryParams, key));
            break;
          case 'sort': {
            const sortParts = _.get(vm.queryParams, key, '').split('|');
            while (sortParts.length > 1) {
              _.set(acc, [key, sortParts.shift()], sortParts.shift());
            }
            break;
          }
          case 'filter': {
            const filterParts = _.get(vm.queryParams, key, '').split('|');
            _.forEach(filterParts, (filterExp) => {
              const [filterKey, filterVal] = filterExp.split('__');
              _.set(acc, [key, filterKey], filterVal);
            });
            break;
          }
          default:
            break;
        }
      }
      return acc;
    }, {});

    _.merge(vm.tableOptions, options);
  }

  function createDataTable() {
    vm.tableParams = new NgTableParams(vm.tableOptions, {
      count: 0,
      getData
    });
  }

  function flagEvent(event) {
    event.flagged = !event.flagged;
    ReportsService.updateEvent(event.id, { flagged: event.flagged })
      .catch(() => {
        event.flagged = !event.flagged;
      });
  }

  function saveEventNotes(event) {
    if (event.$edit) {
      ReportsService.updateEvent(event.id, { notes: event.notes })
        .then(() => {
          event.$edit = false;
        });
    } else {
      event.$edit = true;
    }
  }

  function safeDeleteQueryParams() {
    if (_.isEmpty(vm.listOfDashboards) || _.isEmpty(vm.eventNamesConfig)) {
      return;
    }
    if (_.some(['start', 'end', 'dashboard', 'eventTypes'], param => Boolean(vm.queryParams[param]))) {
      vm.isLoading = false;
      generateEventsReport();
    }
    delete vm.queryParams;
  }
}
